/*
  DESIGN 23 Sep 2026 (CRO mentor item 10, SMM): sold-out choices move to the end of their row and are
  marked, and it updates as she picks. Pick a size, and the colours that size is sold out in drop to the
  end; pick a colour, and the sizes sold out in that colour drop to the end.

  Reads the variant list rendered by sections/main-product.liquid as [data-kn-oos-variants].
  Re-runs after Dawn re-renders the buy box (it replaces the markup on every variant change).
  Revert: remove the kn-oos.js script tag and the [data-kn-oos-variants] block in main-product.liquid.
*/
(function () {
  var cache = null;

  function variants() {
    var el = document.querySelector('[data-kn-oos-variants]');
    if (!el) return null;
    if (cache && cache.el === el) return cache.data;
    try {
      cache = { el: el, data: JSON.parse(el.textContent) };
      return cache.data;
    } catch (e) {
      return null;
    }
  }

  var busyGuard;
  function apply() {
    var list = variants();
    if (!list || !list.length) return;
    var info = document.querySelector('product-info') || document;
    var sets = [].slice.call(info.querySelectorAll('fieldset.product-form__input'));
    if (!sets.length) return;

    var chosen = sets.map(function (fs) {
      var c = fs.querySelector('input[type="radio"]:checked');
      return c ? c.value : null;
    });

    sets.forEach(function (fs, i) {
      var inputs = [].slice.call(fs.querySelectorAll('input[type="radio"]'));
      if (inputs.length < 2) return;
      var tail = [];

      inputs.forEach(function (input) {
        var value = input.value;
        var possible = list.some(function (v) {
          if (!v.a) return false;
          if (v.o[i] !== value) return false;
          for (var j = 0; j < chosen.length; j++) {
            if (j === i || !chosen[j]) continue;
            if (v.o[j] !== chosen[j]) return false;
          }
          return true;
        });

        var label = fs.querySelector('label[for="' + input.id.replace(/(["\\])/g, '\\$1') + '"]');
        input.classList.toggle('kn-oos', !possible);
        input.classList.toggle('disabled', !possible); // Dawn already fades and lines these
        if (label) label.classList.toggle('kn-oos', !possible);
        if (!possible) tail.push([input, label]);
      });

      /* sold-out ones to the end, in the order they were — only touch the DOM if it is not already so */
      if (!tail.length) return;
      var order = [].slice.call(fs.children);
      var lastRadios = order.filter(function (n) { return n.tagName === 'INPUT'; }).slice(-tail.length);
      var alreadyLast = lastRadios.length === tail.length && lastRadios.every(function (n, k) { return n === tail[k][0]; });
      if (alreadyLast) return;
      busy = true;
      tail.forEach(function (pair) {
        fs.appendChild(pair[0]);
        if (pair[1]) fs.appendChild(pair[1]);
      });
      busy = false;
    });
  }

  var pending = null;
  var busy = false;
  function schedule() {
    if (pending || busy) return;
    pending = setTimeout(function () {
      pending = null;
      apply();
      thumbArrows();
    }, 60);
  }

  /*
    DESIGN 24 Sep 2026: the theme hides sold-out combinations, so when a shopper picks a colour that is
    sold out in the size they have chosen, Dawn finds no variant, re-renders nothing, and the photo
    gallery keeps showing the PREVIOUS colour. Two steps fix it:
      1. pick the first size that is actually in stock in the colour they clicked, which makes Dawn
         re-render normally (and shows them a size they can buy);
      2. if the whole colour is sold out, fetch that colour's section from Shopify and swap the gallery
         in, so the photos still match the colour on screen.
    Revert: delete followColour() and its listener.
  */
  var fetching = false;
  function followColour() {
    var list = variants();
    if (!list || !list.length) return;
    var info = document.querySelector('product-info');
    if (!info) return;
    var sets = [].slice.call(info.querySelectorAll('fieldset.product-form__input'));
    if (sets.length < 2) return;

    var colourIndex = -1;
    sets.forEach(function (fs, i) {
      if (fs.classList.contains('product-form__input--swatch')) colourIndex = i;
    });
    if (colourIndex < 0) return;

    var chosen = sets.map(function (fs) {
      var c = fs.querySelector('input[type="radio"]:checked');
      return c ? c.value : null;
    });
    var colour = chosen[colourIndex];
    if (!colour) return;

    var mine = list.filter(function (v) { return v.o[colourIndex] === colour; });
    if (!mine.length) return;

    /* 1. a size that is in stock in this colour */
    var ok = mine.filter(function (v) { return v.a; });
    if (ok.length) {
      var needed = ok[0];
      var changed = false;
      sets.forEach(function (fs, i) {
        if (i === colourIndex) return;
        var want = needed.o[i];
        var inputs = [].slice.call(fs.querySelectorAll('input[type="radio"]'));
        var current = inputs.filter(function (x) { return x.checked; })[0];
        if (current && current.value !== want) {
          var target = inputs.filter(function (x) { return x.value === want; })[0];
          if (target) { target.checked = true; changed = true; }
        }
      });
      if (changed) {
        var any = sets[colourIndex].querySelector('input[type="radio"]:checked');
        if (any) any.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }

    /* 2. the whole colour is sold out: fetch its gallery */
    var marker = document.querySelector('[data-kn-gallery-colour]');
    var showing = marker ? marker.dataset.knGalleryColour : null;
    if (!showing || showing === colour || fetching) return;
    var sectionId = info.dataset.section;
    var url = (info.dataset.url || location.pathname) + '?variant=' + mine[0].id + '&section_id=' + sectionId;
    fetching = true;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html');
        var newGallery = fresh.querySelector('media-gallery');
        var oldGallery = document.querySelector('media-gallery');
        var newMarker = fresh.querySelector('[data-kn-gallery-colour]');
        if (newGallery && oldGallery) {
          oldGallery.replaceWith(newGallery);
          if (marker && newMarker) marker.dataset.knGalleryColour = newMarker.dataset.knGalleryColour;
        }
      })
      .catch(function () {})
      .then(function () { fetching = false; });
  }

  /* DESIGN 24 Sep 2026 (SMM): up/down arrows on the thumbnail strip, so a long list can be scrolled
     without a trackpad gesture. Desktop/tablet only — phones swipe the big photos instead. */
  function thumbArrows() {
    if (window.innerWidth < 750) return;
    var list = document.querySelector('.thumbnail-list');
    if (!list) return;
    var wrap = list.closest('slider-component') || list.parentElement;
    if (!wrap) return;

    var up = wrap.querySelector('.kn-thumb-arrow--up');
    var down = wrap.querySelector('.kn-thumb-arrow--down');
    var chevron = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 15l7-7 7 7" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';

    if (!up) {
      up = document.createElement('button');
      up.type = 'button';
      up.className = 'kn-thumb-arrow kn-thumb-arrow--up';
      up.setAttribute('aria-label', 'Previous photos');
      up.innerHTML = chevron;
      up.addEventListener('click', function () { list.scrollBy({ top: -list.clientHeight * 0.7, behavior: 'smooth' }); });
      wrap.appendChild(up);
    }
    if (!down) {
      down = document.createElement('button');
      down.type = 'button';
      down.className = 'kn-thumb-arrow kn-thumb-arrow--down';
      down.setAttribute('aria-label', 'More photos');
      down.innerHTML = chevron;
      down.addEventListener('click', function () { list.scrollBy({ top: list.clientHeight * 0.7, behavior: 'smooth' }); });
      wrap.appendChild(down);
    }

    function refresh() {
      var more = list.scrollHeight > list.clientHeight + 2;
      up.hidden = !more || list.scrollTop <= 2;
      down.hidden = !more || list.scrollTop + list.clientHeight >= list.scrollHeight - 2;
    }
    if (!list.dataset.knArrows) {
      list.dataset.knArrows = '1';
      list.addEventListener('scroll', refresh, { passive: true });
      window.addEventListener('resize', refresh);
    }
    refresh();
  }

  function start() {
    apply();
    thumbArrows();
    document.addEventListener('shopify:section:load', thumbArrows);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') setTimeout(followColour, 30);
    });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') schedule();
    });
    var info = document.querySelector('product-info');
    if (info && window.MutationObserver) {
      new MutationObserver(schedule).observe(info, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
